// New-convention layers: no version number, architecture-based naming
const NEW_CONVENTION_PATTERN = /^NewRelic(DotNet|Python|NodeJS)(X86|ARM64)?(-\w+)?$/i;
const EXTENSION_PATTERN = /^NewRelicLambdaExtension(ARM64)?(-\w+)?$/;
const AGENT_JAVA_PATTERN = /^NewRelicAgentJava(ARM64)?(-\w+)?$/i;

export const parseLayerData = (layer) => {
  const { LayerName, LatestMatchingVersion } = layer;
  const { Description, LayerVersionArn } = LatestMatchingVersion;

  let runtime = 'Unknown';
  let runtimeVersion = '';
  let architecture = 'x86_64';
  let extensionVersion = 'N/A';
  let agentVersion = 'N/A';
  let convention = 'legacy';

  // Detect architecture from layer name (handles suffixes like -slim)
  if (LayerName.includes('ARM64')) {
    architecture = 'arm64';
  } else if (LayerName.includes('X86')) {
    architecture = 'x86_64';
  }

  if (EXTENSION_PATTERN.test(LayerName)) {
    runtime = 'Go';
    runtimeVersion = 'Extension-Only';
    convention = 'new';
  } else if (AGENT_JAVA_PATTERN.test(LayerName)) {
    runtime = 'Java';
    runtimeVersion = 'java-agent';
    convention = 'new';
  } else if (NEW_CONVENTION_PATTERN.test(LayerName)) {
    // New convention: NewRelicDotnet, NewRelicPythonX86, NewRelicNodeJSARM64, etc.
    const match = LayerName.match(NEW_CONVENTION_PATTERN);
    const runtimeMap = {
      'dotnet': '.NET',
      'python': 'Python',
      'nodejs': 'Node.js'
    };
    runtime = runtimeMap[match[1].toLowerCase()];
    runtimeVersion = runtime.toLowerCase() === '.net' ? 'dotnet' : runtime.toLowerCase();
    convention = 'new';
  } else {
    const runtimeMatch = LayerName.match(/NewRelic(DotNet|Java|NodeJS|Python|Ruby)(\d*X?)/i);
    if (runtimeMatch) {
      const runtimeMap = {
        'dotnet': '.NET',
        'java': 'Java',
        'nodejs': 'Node.js',
        'python': 'Python',
        'ruby': 'Ruby'
      };
      runtime = runtimeMap[runtimeMatch[1].toLowerCase()];
      const rawVersion = runtimeMatch[2];

      if (runtime === '.NET') {
        if (rawVersion === '6') {
          runtimeVersion = 'dotnet6';
        } else if (rawVersion === '8') {
          runtimeVersion = 'dotnet8';
        } else {
          runtimeVersion = `dotnet${rawVersion}`;
        }
      } else if (runtime === 'Python' && rawVersion.length > 1) {
        runtimeVersion = `python${rawVersion.slice(0, 1)}.${rawVersion.slice(1)}`;
      } else if (runtime === 'Ruby' && rawVersion.length > 1) {
        runtimeVersion = `ruby${rawVersion.slice(0, 1)}.${rawVersion.slice(1)}`;
      } else if (runtime === 'Java' && rawVersion) {
        if (rawVersion === '8') {
          runtimeVersion = 'java8.al2';
        } else {
          runtimeVersion = `java${rawVersion}`;
        }
      } else if (runtime === 'Node.js' && rawVersion) {
        runtimeVersion = `nodejs${rawVersion.replace('X', '.x')}`;
      } else if (rawVersion) {
        runtimeVersion = rawVersion.replace('X', '.x');
      } else {
        runtimeVersion = 'N/A';
      }
    }
  }

  const extensionMatch = Description.match(/Extension v([\d.]+)/);
  if (extensionMatch) {
    extensionVersion = `v${extensionMatch[1]}`;
  }

  const agentMatch = Description.match(/(?:Node|Python|Java|Ruby|DotNet) Agent v([\d.]+)/i);
  if (agentMatch) {
    agentVersion = `v${agentMatch[1]}`;
  }

  return {
    id: LayerVersionArn,
    runtime,
    runtimeVersion,
    architecture,
    extensionVersion,
    agentVersion,
    arn: LayerVersionArn,
    convention,
  };
};

// Get color-coded badge class for runtime versions
export const getRuntimeBadgeClass = (runtime, runtimeVersion) => {
  const baseClass = 'runtime-badge';
  
  if (runtime === 'Python') {
    return `${baseClass} runtime-badge-python`;
  } else if (runtime === 'Node.js') {
    return `${baseClass} runtime-badge-nodejs`;
  } else if (runtime === 'Java') {
    return `${baseClass} runtime-badge-java`;
  } else if (runtime === 'Ruby') {
    return `${baseClass} runtime-badge-ruby`;
  } else if (runtime === 'Go') {
    return `${baseClass} runtime-badge-go`;
  } else if (runtime === '.NET') {
    return `${baseClass} runtime-badge-dotnet`;
  }
  
  return baseClass;
};
